import { Component, ViewEncapsulation } from "@angular/core";
import { ITooltipAngularComp } from "ag-grid-angular";
import { ITooltipParams } from "ag-grid-community";
import { format, parseISO } from "date-fns";
import { PpsUtilityService } from "../services/pps-utility.service";
import { RosterService } from "../services/roster.service";
import { IEmployeeRoster } from "../shared/models/roster/employee-roster";
import { IRosterNote } from "../shared/models/roster/roster-note";
import * as _ from "lodash";
import { IRosterEmployeeNote } from "../shared/models/roster/roster-employee-note";

@Component({
  selector: "pps-roster-tooltip",
  templateUrl: "./roster-tooltip.component.html",
  styles: [`
     :host {
        position: absolute;
        overflow: visible;
        pointer-events: none;
        transition: opacity 1s;
      }

      :host.ag-tooltip-hiding {
        opacity: 0;
      }
      
      .zoesen-tooltip-header .p-panel-content{
        display: none;
      }
  `],
  encapsulation: ViewEncapsulation.None
})
export class RosterTooltipComponent implements ITooltipAngularComp{
  private params: { type: string } & ITooltipParams;
  rosterNote: IRosterNote;
  header: boolean = false;
  content: string = "";
  footer: string = "";
  title: string = "";

  constructor(
    private _util: PpsUtilityService,
    private _rosterService: RosterService
    ) {
  }

  agInit(params: { type: string } & ITooltipParams): void {
    this.params = params;

    if (params.location === "cell"){
      this.header = false;
      if (params.value && params.value === "roster-note"){
        var day = format(params.colDef["rosterDay"], "yyyyMMdd");

        var rosterNote = params.data.values[day].rn;
        this.title = format(params.colDef["rosterDay"], "dd/MM/yyyy")
        this.content = this.toHTML(rosterNote?.note);

        var dateStr = "";
        try{
          if (_.isString(rosterNote?.updateDate)){
            dateStr = format(parseISO(rosterNote?.updateDate), 'dd/MM/yyyy HH:mm:ss')
          }else{
            dateStr = format(rosterNote?.updateDate, "dd/MM/yyyy HH:mm:ss");
          }
        }catch(e){}

        this.footer = `Last updated by ${rosterNote?.updateByLastName}, ${rosterNote?.updateByFirstName} on ${dateStr}`;
      }

      if (params.value && params.value === "inactive-employee"){
        var empRoster = params.data as IEmployeeRoster;
        this.title = "Resigned Employee";
        this.content = `To replace ${this._util.getEmployeeName(empRoster.employee)}.`;
        this.footer = `Terminated on ${format(empRoster.employee.terminateDate, "dd/MM/yyyy")} with note: ${empRoster.employee.terminateNote || ""}`;
      }

      if (params.value && params.value === "employee-note"){
        var empRoster = params.data as IEmployeeRoster;
        let colId = params.colDef["colId"];
        let empId = empRoster.employee.id;
        let parent = params.context.componentParent
        if (parent.getRosterEmployeeNote){
          let rosterEmployeeNote: IRosterEmployeeNote = parent.getRosterEmployeeNote(empId, colId);
          if (rosterEmployeeNote){
            this.title = this._util.getEmployeeName(empRoster.employee) + " - " + this._rosterService.getColumnName(colId);
            this.content = this.toHTML(rosterEmployeeNote?.note);
            this.footer = `Last updated by ${rosterEmployeeNote.updateBy} on ${format(rosterEmployeeNote.updateDate, "dd/MM/yyyy HH:mm:ss")}`;
          }
        }
      }
    }

    if (params.location === "header"){
      this.header = true;
      this.title = params.value;
    }
  }

  private toHTML(data: string){
    return (data || "").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "<br />");
  }
}
